const setDefaultAgent = async ({ commit, rootGetters, dispatch }, payload) => {
  try {
    const customer = rootGetters["customer/CUSTOMER"];
    const selected_customer = rootGetters["customer/SELECTED_CUSTOMER"];

    let customer_id = customer.customer_id;
    if (customer.customer_id === 0) {
      customer_id = selected_customer.customer_id;
    }

    const response = await window.axios.put(
      `/proxy/ai/customers/${customer_id}/default-workspace`,
      { workspaceId: payload.workspaceId }
    );

    if (response && response.data.success) {
      // Update the customer's default workspace ID in the store without full refresh
      const updatedCustomer = {
        ...customer,
        CustomersFeature: {
          ...customer.CustomersFeature,
          default_workspace_id: payload.workspaceId
        }
      };
      commit("customer/SET_CUSTOMER", updatedCustomer, { root: true });

      dispatch("notifications/setSuccess",
        `Agent has been set as default for your organization`,
        { root: true }
      );
      return response.data;
    } else {
      throw new Error(response.data?.message || 'Failed to set default agent');
    }
  } catch (error) {
    dispatch("notifications/setError",
      error.response?.data?.message || error.message || 'Failed to set default agent',
      { root: true }
    );
    throw error;
  }
};

export default setDefaultAgent;